import React, { FC, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import useOutsideClick from "hooks/click-outside";
import { ReactComponent as Arrow } from "assets/images/svgs/ambassador/arrow-right.svg";
import NewPost from "./new-post";
import useStore from "hooks/useStore";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes";

interface FamilyEngagementProps {
  isOpen: boolean;
  handleConfirm: () => void;
  onClose: () => void;
}

const EventSupport: FC<FamilyEngagementProps> = ({
  isOpen,
  onClose,
  handleConfirm,
}) => {
  const modalRef = useOutsideClick(() => {
    if (isOpen) onClose();
  });
 const navigate = useNavigate()
   const { getAmbassadorTierResposibilities } = useStore()
  const ambassadorTierResposibilities = getAmbassadorTierResposibilities();
  
  const goToJoinEvent = () => {
    navigate(siteRoutes.ambassadorJoinEvents)
  }


  if (!isOpen ) return null;

  return (
    <>
      {isOpen && (
        <div
          className={`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300 ${
            isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
          style={{ zIndex: 'calc(var(--z-modal) + 1)' }}
        >
          <div
            ref={modalRef}
            className={`relative bg-white px-4 sm:px-6 md:px-10 py-6 sm:py-8 md:py-12 rounded-lg shadow-lg w-[90%] sm:w-[500px] md:w-[550px] transform transition-transform duration-300 ${
              isOpen ? "scale-100" : "scale-95"
            }`}
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 transition"
            >
              <AiOutlineClose size={20} />
            </button>

            <h2 className="text-xl sm:text-2xl font-bold text-center mb-2 text-rsvpBlackie">
              Event Support
            </h2>
            <p className="text-center text-sm sm:text-base md:text-lg text-rsvpBlackie mb-6 sm:mb-8">
              Spread the Learn Local message with Event Support
            </p>

            <div className="space-y-3">
              <button
                className="w-full flex items-center justify-between bg-[#F8F8F8] px-3 sm:px-4 py-2.5 sm:py-3 rounded-xl hover:bg-[#E8E8E8] transition"
                onClick={goToJoinEvent}
              >
                <div className="flex flex-col text-left flex-1 pr-2">
                  <span className="text-base sm:text-lg font-semibold text-rsvpBlackie">
                    Learn Local Event Attendance
                  </span>
                  <span className="text-xs sm:text-sm text-rsvpBlackie mt-1">
                    Attend {ambassadorTierResposibilities?.eventSupport?.attendance?.quantity} event and volunteer
                  </span>
                </div>
                <Arrow className="w-6 h-6 sm:w-8 sm:h-8 flex-shrink-0" />
              </button>

             
            </div>
          </div>
        </div>
      )}

      {/* {showNewPost && (
        <NewPost
          isOpen={showNewPost}
          onClose={() => {
            setShowNewPost(false);
            onClose(); // closes FamilyEngagement when done
          }}
          handleConfirm={handleConfirm}
        />
      )} */}
    </>
  );
};

export default EventSupport;
